<!-- Alert -->
<fuse-alert
    class="mt-8 top-0 right-0 absolute z-99"
    *ngIf="showAlert"
    [appearance]="'outline'"
    [showIcon]="false"
    [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
</fuse-alert>

 
<div class="min-h-100 mb-24" *ngIf="loading"> 
    <ngx-skeleton-loader [theme]="{height:'400px',width:'2000px'}" ></ngx-skeleton-loader>
</div>
<div class="w-full" *ngIf="!loading">

    <div *ngIf="accountInArrears">
        <div class="md:mx-24 mt-12 max-sm:mx-8 cursor-pointer" routerLink="/balances">
            <div class="bg-red-500 w-full rounded-xl p-4 text-white text-center items-center justify-center flex">
                <mat-icon class="text-white scale-110 mr-4">warning</mat-icon>
                <p>Your account is in arrears. <a class="underline underline-offset-2 mr-1.5">Please make payment</a>to ensure your service does not get suspended.</p>
            </div>
        </div>
    </div>

    <div *ngIf="latestPendingDO">
        <div class="md:mx-24 mt-12 max-sm:mx-8 cursor-pointer" (click)="viewLatestDebitOrder()">
            <div class="bg-red-500 w-full rounded-xl p-4 text-white text-center items-center justify-center flex">
                <mat-icon class="text-white scale-110 mr-4">warning</mat-icon>
                <p>
                    You have a pending Debit Order Mandate on your account <br>
                    Click <a class="underline underline-offset-2 mr-1.5">here</a> to view your Debit Order Mandate
                </p>
            </div>
        </div>
    </div>

    <div *ngIf="preorders.length">
        <div class="md:mx-24 mt-12 max-sm:mx-8">
            <div class="bg-success w-full rounded-xl p-4 text-white text-center">
                You have a pending pre-order in progress. Please complete the order to activate the service.
            </div>
        </div>
    </div>

    <section>
        <div class="md:mx-24 mt-12 max-sm:mx-8">
            <h1 class="text-4xl font-extrabold">
                Hi, {{customerAccount?.PrimaryContactName}}
            </h1>
            <p class="text-2xl font-medium">
                Welcome to your Supersonic account.
            </p>
            <hr>
            <app-payment-methods [validPayment]="validPayment"
                [currentPaymentMethod]="_sharedService.customerPaymentMethod" [dashboardProcessView]="true"></app-payment-methods>
        </div>
    </section>
    <section>
        <div class="flex flex-col w-full my-12 justify-center max-sm:flex-col items-center space-y-4">
            <div class="flex-row flex justify-center w-full">
                <fuse-card class="flex flex-col text-left lg:min-w-52 mx-4 p-8 shadow-lg drop-shadow max-lg:w-1/2 max-sm:p-4 max-sm:min-h-50 items-center  hover:cursor-pointer" (click)="goToAnchor('services')">
                    <div>
                        <h1 class="text-8xl font-black">{{servicesLength || 0}}</h1>
                    </div>
                    <div>
                        <p class="text-2xl font-semibold max-sm:text-xl">{{ servicesLength === 1 ? "Service" : "Services" }}</p>
                    </div>
                </fuse-card>
                <fuse-card routerLink="/dashboard/requests" class="flex flex-col text-left lg:min-w-52 mx-4 p-8 shadow-lg drop-shadow max-lg:w-1/2 max-sm:p-4 max-sm:min-h-50 hover:cursor-pointer items-center">
                    <div>
                        <h1 class="text-8xl font-black">{{requestAmount || 0}}</h1>
                    </div>
                    <div>
                        <p class="text-2xl font-semibold max-sm:text-xl">{{ requestAmount === 1 ? "Request" : "Requests" }}</p>
                    </div>
                </fuse-card>
                <fuse-card class="flex flex-col text-left lg:min-w-52 mx-4 p-8 shadow-lg drop-shadow max-lg:w-1/2 max-sm:p-4 max-sm:min-h-50 hover:cursor-pointer items-center " (click)="goToAnchor('orders')">
                    <div>
                        <h1 class="text-8xl font-black">{{orderLength || 0}}</h1>
                    </div>
                    <div>
                        <p class="text-2xl font-semibold max-sm:text-xl">{{ orderLength === 1 ? "Order" : "Orders" }}</p>
                    </div>
                 </fuse-card>
            </div>
        </div>
    </section>



    <section *ngIf="services && services.length" id="services">
        <div class="mx-24 mt-8 md:mt-24 max-sm:mx-4">
            <div class='flex flex-row justify-between items-center'>
                <div class="flex flex-row max-sm:flex-col max-sm:text-center max-sm:w-full items-center">
                    <h1 class="lg:text-4xl text-2xl font-extrabold text-primary">
                        My Connectivity
                    </h1>
                    <button class="mt-2 text-lg font-bold md:mx-4 bg-accent text-black" mat-flat-button [routerLink]="['/']">
                        Add product
                    </button>
                </div>
            </div>
            <hr class="mt-4">
        </div>
    </section>

    <section *ngIf="services && services.length == 0 && preorderLength == 0 && orderLength == 0 " class="flex justify-center items-center">
        <div class="flex flex-row w-full px-4 md:w-3/5">
            <div class="flex flex-col">
                <fuse-card class="bg-primary p-4">
                    <mat-icon class="text-white text-3xl">wifi_off</mat-icon>
                </fuse-card>
            </div>
            <div class="flex flex-col ml-4">
                <h1 class="text-2xl font-bold self-start">
                    No orders
                </h1>
                <p class="text-xl mt-2">
                    You currently have no active services. Please use the Check coverage  to start.
                </p>
                <button
                    [routerLink]="['/home']"  
                    class="mt-4 text-lg font-bold hover:cursor-pointer bg-accent self-start" mat-flat-button>
                    Check coverage 
                </button>
            </div>
        </div>
     </section>


    <section *ngIf="services && services.length">
        <div class="flex flex-row w-full max-sm:flex-col justify-center items-center" >
            <div class="flex flex-col md:w-3/4 lg:w-1/2 xl:w-1/2">
               <app-services (servicesLength)="getServicesNumber($event)" [ordersLength]="orderLength"></app-services>
            </div>
        </div>
    </section>

    <!---------------------------------------------------------------------->
    <!--------------------------- PreOrders -------------------------------->
    <!---------------------------------------------------------------------->

    <section *ngIf="preorderLength >= 1">
        <div class="mt-24 md:mx-24 mx-8">
            <div class='flex flex-row justify-between'>
                <div class="flex flex-row">
                    <h1 class="lg:text-4xl text-3xl  font-extrabold text-primary">
                        Pre-Orders in progress: {{_sharedService.sortedDebitOrdersArray?.length}}
                    </h1>
                </div>
            </div>
            <hr class="mt-4 ">
            <div class="md:mx-24">
                <app-orders [orderList]="preorders"></app-orders>
            </div>
        </div>
    </section>

    <!---------------------------------------------------------------------->
    <!----------------------------- Orders --------------------------------->
    <!---------------------------------------------------------------------->
    
    <section *ngIf="orderLength >= 1" id="orders">
        <div class="mt-24 md:mx-24 mx-8">
            <div class='flex flex-row justify-between'>
                <div class="flex flex-row">
                    <h1 class="lg:text-4xl text-3xl font-extrabold text-primary">
                        Orders in progress: {{_sharedService.sortedDebitOrdersArray?.length}}
                    </h1>
                </div>
            </div>
            <hr class="mt-4 ">
            <div class="md:mx-24">
                <app-orders [orderList]="orders" [customerAccount]="customerAccount"></app-orders>
            </div>
        </div>
    </section>

    <section>
        <div class="mt-24 md:mx-24 mx-8">
            <div class='flex flex-row justify-between'>
                <div class="flex flex-row">
                    <h1 class="lg:text-4xl text-3xl  font-extrabold text-primary">
                        My Account
                    </h1>
                </div>
            </div>
            <hr class="mt-4 ">
        </div>
        <div class="flex flex-wrap justify-left md:mx-24 md:mb-64 mb-24">
            <div class="md:w-1/3 px-4 w-full">
                <fuse-card class="p-4 cursor-pointer shadow-md"   [routerLink]="'/dashboard/profile'">
                    <div class="flex-row flex items-center">
                        <fuse-card class="bg-primary p-4">
                            <mat-icon class="text-white text-3xl">account_box</mat-icon>
                        </fuse-card>

                        <h1 class="text-2xl font-bold ml-4">
                            Profile
                        </h1>

                    </div>
                </fuse-card>
            </div>
            <div class="md:w-1/3 px-4 w-full max-sm:mt-4">
                <fuse-card class="p-4 cursor-pointer shadow-md"  [routerLink]="'/dashboard'">
                    <div class="flex-row flex items-center">
                        <fuse-card class="bg-primary p-4">
                            <mat-icon class="text-white text-3xl">wifi</mat-icon>
                        </fuse-card>

                        <h1 class="text-2xl font-bold ml-4">
                            Active services
                        </h1>

                    </div>
                </fuse-card>
            </div>
            <div class="md:w-1/3 px-4 w-full max-sm:mt-4">
                <fuse-card class="p-4 cursor-pointer shadow-md"   [routerLink]="'/dashboard/invoices'">
                    <div class="flex-row flex items-center">
                        <fuse-card class="bg-primary p-4">
                            <mat-icon class="text-white text-3xl">credit_card</mat-icon>
                        </fuse-card>

                        <h1 class="text-2xl font-bold ml-4">
                            Billing & Statements
                        </h1>
                    </div>
                </fuse-card>
            </div>
            <div class="md:w-1/3 px-4 mt-12 w-full  max-sm:mt-4">
                <fuse-card class="p-4 cursor-pointer shadow-md" [routerLink]="'/dashboard/requests'">
                    <div class="flex-row flex items-center">
                        <fuse-card class="bg-primary p-4">
                            <mat-icon class="text-white text-3xl">contact_support</mat-icon>
                        </fuse-card>
                        <h1 class="text-2xl font-bold ml-4">
                            Support requests
                        </h1>
                    </div>
                </fuse-card>
            </div>
            <div class="md:w-1/3 px-4 mt-12 w-full max-sm:mt-4">
                <fuse-card class="p-4 cursor-pointer shadow-md" [routerLink]="'/contact-us'">
                    <div class="flex-row flex items-center">
                        <fuse-card class="bg-primary p-4">
                            <mat-icon class="text-white text-3xl">notifications</mat-icon>
                        </fuse-card>

                        <h1 class="text-2xl font-bold ml-4">
                            Get help
                        </h1>

                    </div>
                </fuse-card>
            </div>
            <div class="md:w-1/3 px-4 mt-12 w-full max-sm:mt-4">
                <fuse-card class="p-4 cursor-pointer shadow-md" [routerLink]="'/balances'">
                    <div class="flex-row flex items-center">
                        <fuse-card class="bg-primary p-4">
                            <mat-icon class="text-white text-3xl">payments</mat-icon>
                        </fuse-card>

                        <h1 class="text-2xl font-bold ml-4">
                            Pay now
                        </h1>

                    </div>
                </fuse-card>
            </div>
        </div>
    </section>
</div>